import { AC_GROUPS, AC_TYPES } from '../AC.types.constant';
import { CriterionType } from '../../../types/screener.type';

const consensusEstimatesAC: CriterionType[] = [
  {
    id: 'CRE-30',
    label: 'Forward P/E',
    shortLabel: 'FwdP/E',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'CRE-50',
    label: 'Forward dividend yield (%)',
    shortLabel: 'FwdDivYld',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'CRE-10',
    label: 'Forward net income rate',
    shortLabel: 'FwdNIGr',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'CRE-40',
    label: 'Forward revenue growth rate',
    shortLabel: 'FwdRevGr',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'CRE-60',
    label: 'Revenue estimate revision (%)',
    shortLabel: 'RevEstRev',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '3m', '6m', '12m'],
    withRange: true,
  },
  {
    id: 'CRE-20',
    label: 'EPS long-term growth rate',
    shortLabel: 'EPSLTGr',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'REV-60',
    label: 'Target price deviation (est.) (%)',
    shortLabel: 'TPDev(Est)',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.normal,
    withRange: true,
  },
  {
    id: 'REV-20',
    label: 'Change in target price deviation (est.) (%)',
    shortLabel: 'TPDevChg(Est)',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '2m', '3m', '6m', '9m', '12m'],
    withRange: true,
  },
  {
    id: 'REV-10',
    label: 'Broker rating estimate',
    shortLabel: 'Rating(Est)',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '2m', '3m', '6m', '9m', '12m'],
    withRange: true,
  },
  {
    id: 'REV-30',
    label: 'Broker rating change',
    shortLabel: 'RatingChg',
    unit: '%',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '2m', '3m', '6m', '9m', '12m'],
    withRange: true,
  },
  {
    id: 'REV-40',
    label: 'Broker rating upgrade',
    shortLabel: 'RatingUpGrd',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '2m', '3m', '6m', '9m', '12m'],
  },
  {
    id: 'REV-50',
    label: 'Broker rating downgrade',
    shortLabel: 'RatingDnGrd',
    group: AC_GROUPS.consensusEstimates,
    type: AC_TYPES.time,
    timeOptions: ['1m', '2m', '3m', '6m', '9m', '12m'],
  },
];

export default consensusEstimatesAC;
